import { ExportOutlined } from "@ant-design/icons"
import { Button } from "components/Button/Button"
import { useNotification } from "components/Notification/Notification"
import { Enrollment } from "interface/enrollment"
import { useMedicalNecessityFormDocument } from "services/billings"
import { triggerDownload } from "utils/file"

export const MedicalNecessityFormActions = ({
	enrollment,
}: {
	enrollment: Enrollment
}) => {
	const { notify } = useNotification()
	const { mutateAsync: fetchDoc, isPending } = useMedicalNecessityFormDocument(
		enrollment.id,
	)

	if (!enrollment.medicalNecessityForm) {
		return null
	}

	return (
		<Button
			type="link"
			size="small"
			icon={<ExportOutlined aria-hidden />}
			loading={isPending}
			className="px-0 select-none"
			onClick={async (event) => {
				await fetchDoc(undefined, {
					onSuccess: async ({ blob, filename }) => {
						await triggerDownload(blob, event.shiftKey ? filename : undefined)
					},
					onError: (error) => {
						notify.error({
							duration: 0,
							message: "Open medical necessity form",
							description: (
								<div className="flex flex-col gap-2">
									<p>An unexpected error occured:</p>
									<p className="font-bold">{error.message}</p>
								</div>
							),
						})
					},
				})
			}}
		>
			Open
		</Button>
	)
}
